import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const AudioPauseIcon: FunctionComponent<AudioPauseIconProps> = ({ width = 27, height = 38, fillColor }) => {
  const { colors } = useTheme()

  return (
    <Svg width={width} height={height} viewBox='0 0 27 38' fill='none'>
      <Path
        fillRule='evenodd'
        clip-rule='evenodd'
        d='M4.03125 0.1875C6.25765 0.1875 8.0625 2.18406 8.0625 4.64695V33.3531C8.0625 35.8159 6.25765 37.8125 4.03125 37.8125C1.80485 37.8125 0 35.8159 0 33.3531V4.64695C0 2.18406 1.80485 0.1875 4.03125 0.1875Z'
        fill={fillColor || colors.backgroundPrimary}
      />
      <Path
        fillRule='evenodd'
        clip-rule='evenodd'
        d='M22.9688 0.1875C25.1951 0.1875 27 2.15643 27 4.58523V33.4148C27 35.8436 25.1951 37.8125 22.9688 37.8125C20.7424 37.8125 18.9375 35.8436 18.9375 33.4148V4.58523C18.9375 2.15643 20.7424 0.1875 22.9688 0.1875Z'
        fill={fillColor || colors.backgroundPrimary}
      />
    </Svg>
  )
}

type AudioPauseIconProps = {
  height?: string | number
  width?: string | number
  fillColor?: string
}
